@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/components/custom-scroll/custom-scroll' as *;

.styledModal {
  [data-modal-container] {
    width: 95%;
    max-width: 800px;
    height: 100%;
    max-height: 604px;
  }

  [data-modal-text-container] {
    margin: 18px 0 0;
  }

  [data-modal-header] {
    padding: 6px 6px 24px 20px;
  }
}

.container {
  display: flex;
  gap: 20px;
  flex-direction: column;
  padding: 12px 20px;
}

.nodesWrapper {
  @include custom-scroll-minimal;

  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  height: 300px;

  mark {
    color: var(--text-primary);
    background-color: transparent;
  }
}

.search {
  [data-input-wrapper] {
    @include border-radius-r2;

    border: 1px solid var(--border-default);
    padding: 8px 12px;
    width: 100%;
    background-color: transparent;
  }
}

.footerButtons {
  display: flex;
  justify-content: space-between;
  padding: 24px 20px;
}

.confirmationButtons {
  display: flex;
  gap: 8px;
}

.clearButton {
  @include typography-v2-body-sm;

  color: var(--text-soft);
  cursor: pointer;

  &:hover {
    color: var(--text-default);
  }
}

.noResultsLabel {
  color: var(--text-soft);
}
